import { addAlert, removeAlert } from "js/state/actions/alerts/alertMessages"
import ShowMessageDialog from "js/includes/components/MessageDialog"
import { faTrash, faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import { localized } from "js/includes/common/utils/ssrAndWebUtils"

const iconMapper = {
  critical: faTrash,
  warning: faInfoCircle,
}

window.showSuccessMessage = function(message = localized("general.success")) {
  window.store.dispatch(
    addAlert({
      duration: 5000,
      type: "success",
      message,
    }),
  )
}

window.showErrorMessage = function(message) {
  window.store.dispatch(
    addAlert({
      duration: 5000,
      type: "error",
      message,
    }),
  )
}

window.showWarningMessage = function(message) {
  window.store.dispatch(
    addAlert({
      duration: 5000,
      type: "warning",
      message,
    }),
  )
}

window.showPermanentMessage = function(message) {
  const alertId = window.store.dispatch(
    addAlert({
      type: "info",
      message,
    }),
  )

  return () => window.store.dispatch(removeAlert(alertId))
}

export const showSuccessMessage = message => window.showSuccessMessage(message)
export const showErrorMessage = message => window.showErrorMessage(message)
export const showWarningMessage = message => window.showWarningMessage(message)
export const showPermanentMessage = message => window.showPermanentMessage(message)

export async function actionDialog({
  icon,
  type = "critical",
  title = "general.delete",
  message = "general.areYouSureDelete",
  actionButtonLabel = "general.delete",
  actionButtonType = "critical",
} = {}) {
  return await ShowMessageDialog({
    icon: { icon: icon ?? iconMapper[type], type },
    title,
    message,
    buttons: [
      { id: true, label: actionButtonLabel, type: actionButtonType },
      { id: false, label: "general.cancel" },
    ],
  })
}
